export class TransactionalManagementIndicators {
  private openIndicator: number;
  private pendingIndicator: number;
  private confirmedIndicator: number;
  private cancelledIndicator: number;
  private expiredIndicator: number;
  private rejectedIndicator: number;
  private refundIndicator: number;
  private refundedIndicator: number;
  private inconsistentIndicator: number;
  private exceededIndicator: number;

  public getOpenIndicator(): number {
    return this.openIndicator;
  }

  public setOpenIndicator(value: number): void {
    this.openIndicator = value;
  }

  public getPendingIndicator(): number {
    return this.pendingIndicator;
  }

  public setPendingIndicator(value: number): void {
    this.pendingIndicator = value;
  }

  public getConfirmedIndicator(): number {
    return this.confirmedIndicator;
  }

  public setConfirmedIndicator(value: number): void {
    this.confirmedIndicator = value;
  }

  public getCancelledIndicator(): number {
    return this.cancelledIndicator;
  }

  public setCancelledIndicator(value: number): void {
    this.cancelledIndicator = value;
  }

  public getExpiredIndicator(): number {
    return this.expiredIndicator;
  }

  public setExpiredIndicator(value: number): void {
    this.expiredIndicator = value;
  }

  public getRejectedIndicator(): number {
    return this.rejectedIndicator;
  }

  public setRejectedIndicator(value: number): void {
    this.rejectedIndicator = value;
  }

  public getRefundIndicator(): number {
    return this.refundIndicator;
  }

  public setRefundIndicator(value: number): void {
    this.refundIndicator = value;
  }

  public getRefundedIndicator(): number {
    return this.refundedIndicator;
  }

  public setRefundedIndicator(value: number): void {
    this.refundedIndicator = value;
  }

  public getInconsistentIndicator(): number {
    return this.inconsistentIndicator;
  }

  public setInconsistentIndicator(value: number): void {
    this.inconsistentIndicator = value;
  }
  public getExceededIndicator(): number {
    return this.exceededIndicator;
  }

  public setExceededIndicator(value: number): void {
    this.exceededIndicator = value;
  }
}
